import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const vesselReportApi = AiseaApiFactory.get("vesselReport");
const vesselReportConfirmApi = AiseaApiFactory.get("vesselReportConfirm");

export default {
  async fetchReport({ commit }, payload) {
    let resReport = await vesselReportApi.fetch(payload);
    commit("SET_REPORT_DETAILS", resReport.data);

    let resConfirm = await vesselReportConfirmApi.fetch(payload.id);
    commit("SET_CONFIRMOR_LIST", resConfirm.data);
    return true;
  },

  // eslint-disable-next-line no-unused-vars
  async readReport({ commit }, payload) {
    await vesselReportConfirmApi.read(payload);
    return true;
  },

  async resetVesselReportViewState({ commit }) {
    let defaultState = {
      reportDetails: null,
      confirmorList: []
    };
    commit("RESET_STATE", defaultState);
  }

};
